var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5247 17.8466C10.6048 16.8046 11.4737 16 12.5188 16H27.4813C28.5264 16 29.3953 16.8046 29.4754 17.8466L30.5011 31.1799C30.5904 32.3415 29.672 33.3333 28.507 33.3333H11.4931C10.3281 33.3333 9.40967 32.3415 9.49902 31.1799L10.5247 17.8466Z",
    fill: "#0A2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 11.9993C14.6666 9.05383 17.0544 6.66602 20 6.66602C22.9455 6.66602 25.3333 9.05383 25.3333 11.9993V13.3327H22.6666V11.9993C22.6666 10.5266 21.4727 9.33268 20 9.33268C18.5272 9.33268 17.3333 10.5266 17.3333 11.9993V13.3327H14.6666V11.9993Z",
    fill: "#0A2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageAdd);
export default __webpack_public_path__ + "static/media/package_add.24c62b9c7972998ffd861824706fbd6e.svg";
export { ForwardRef as ReactComponent };